import { render, staticRenderFns } from "./DocumentsCard.vue?vue&type=template&id=23b02cd0&scoped=true&"
import script from "./DocumentsCard.vue?vue&type=script&lang=js&"
export * from "./DocumentsCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCard.vue?vue&type=style&index=0&id=23b02cd0&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b02cd0",
  null
  
)

export default component.exports